import {
  READ_NOTIFICATIONS,
  READ_NOTIFICATIONS_SUCCEEDED,
  READ_NOTIFICATIONS_FAILED,
  MARK_READ_ONE,
  MARK_READ_ONE_SUCCEEDED,
  MARK_READ_ONE_FAILED,
  MARK_READ_ALL,
  MARK_READ_ALL_SUCCEEDED,
  MARK_READ_ALL_FAILED,
  CONNECT_WEBSOCKET,
  DISCONNECT_WEBSOCKET,
  WEBSOCKET_CONNECTION_FAILED,
  WS_NOTIFICATIONS_ADD_MSG,
} from "./types"

export const readNotifications = config => {
  return { type: READ_NOTIFICATIONS, config }
}

export const readNotificationsSuccess = (action, response) => {
  return { type: READ_NOTIFICATIONS_SUCCEEDED, action, response }
}

export const readNotificationsError = (action, error) => {
  return { type: READ_NOTIFICATIONS_FAILED, action, error }
}

export const markOneRead = config => {
  return { type: MARK_READ_ONE, config }
}

export const markOneReadSuccess = (action, response) => {
  return { type: MARK_READ_ONE_SUCCEEDED, action, response }
}

export const markOneReadError = (action, error) => {
  return { type: MARK_READ_ONE_FAILED, action, error }
}

export const markAllRead = config => {
  return { type: MARK_READ_ALL, config }
}

export const markAllReadSuccess = (action, response) => {
  return { type: MARK_READ_ALL_SUCCEEDED, action, response }
}

export const markAllReadError = (action, error) => {
  return { type: MARK_READ_ALL_FAILED, action, error }
}

export const connectWebsocket = () => ({
  type: CONNECT_WEBSOCKET,
})

export const disconnectWebsockets = () => ({
  type: DISCONNECT_WEBSOCKET,
})

export const connectWebsocketsFailed = () => ({
  type: WEBSOCKET_CONNECTION_FAILED,
})

export const wsAddMsg = (action, response) => {
  return { type: WS_NOTIFICATIONS_ADD_MSG, action, response }
}
